import { isBuildChannel, type BuildChannel } from "~/interface/AppControl";

/**
 * bundle ชุดนี้ถูก build มาสำหรับ channel ไหน
 *
 * ค่าจริงมาจาก BUILD_TARGET ตอน build ฝังไว้ที่ runtimeConfig.public.buildChannel
 * (ดู nuxt.config.ts + sentryRelease.mjs) — เชื่อค่านี้ได้ เพราะ package.json มี
 * deploy แยกกันสามตัว (deploy / deploy_beta / deploy_preview) แต่ละตัวสั่ง
 * `npm run generate` ของตัวเองพร้อม BUILD_TARGET ของตัวเอง ไฟล์ที่ขึ้นแต่ละ
 * hosting site จึงเป็นคนละชุดกันจริง ๆ ไม่ใช่ build เดียวแปะสองที่
 * เลยไม่ยึด hostname เป็นหลัก
 *
 * hostname เหลือไว้เป็นทางหนีทีไล่กรณีเดียว: bundle ที่ build ตอนที่ยังไม่มี
 * BUILD_TARGET (ของเก่า หรือ build มือ) ถูก deploy ขึ้น hosting site จริง
 * ถ้าปล่อยให้ตกเป็น development เครื่องหน้าร้านจะไปฟัง channel ผิดตัวเงียบ ๆ
 *
 * host ที่ไม่รู้จัก (LAN IP, เครื่อง dev, พรีวิวชั่วคราว) ไม่ถูกเหมาเป็น production
 * — เดาผิดเป็น production คือเคสที่แพงที่สุด
 */
export function useBuildChannel(): BuildChannel {
  const embedded = useRuntimeConfig().public.buildChannel;

  // "development" = ไม่ได้ตั้ง BUILD_TARGET ตอน build ไม่ใช่คำตอบที่ยืนยันอะไรได้
  if (isBuildChannel(embedded) && embedded !== "development") return embedded;

  return channelFromHostname();
}

const LOCAL_HOSTNAMES = ["localhost", "127.0.0.1", "0.0.0.0", "[::1]"];

/** hosting site ที่รู้จักแน่ ๆ (ดู firebase.json + npm script deploy) */
const HOSTNAME_CHANNEL: Record<string, BuildChannel> = {
  "app2.xtable.co": "beta",
  "xtable-v3.web.app": "beta",
  "xtable-v3.firebaseapp.com": "beta",
  "xtable-882df.web.app": "production",
  "xtable-882df.firebaseapp.com": "production",
};

function channelFromHostname(): BuildChannel {
  if (!process.client) return "development";

  const hostname = window.location.hostname.toLowerCase();

  if (LOCAL_HOSTNAMES.includes(hostname)) return "development";

  const known = HOSTNAME_CHANNEL[hostname];
  if (known) return known;

  // URL ของ firebase hosting preview channel หน้าตาแบบ
  // xtable-v3--preview-site-xxxxxxxx.web.app — เช็คก่อน .xtable.co
  if (hostname.includes("--")) return "preview";

  // โดเมนจริงของลูกค้าอยู่ใต้ xtable.co ทั้งหมด และ beta ถูกดักไปแล้วข้างบน
  if (hostname === "xtable.co" || hostname.endsWith(".xtable.co")) {
    return "production";
  }

  return "development";
}
